import { t } from '@lingui/macro';
import * as yup from 'yup';

const primaryContactValidationSchema = yup.object({
  primaryContactOption: yup
    .string()
    .oneOf(['new', 'existing'])
    .required(t`Select a contact option`),
  primaryContactFirstName: yup.string().when('primaryContactOption', {
    is: 'new',
    then: (schema) => schema.required(t`First Name is required`),
  }),
  primaryContactLastName: yup.string().when('primaryContactOption', {
    is: 'new',
    then: (schema) => schema.required(t`Last Name is required`),
  }),
  primaryContactEmail: yup.string().when('primaryContactOption', {
    is: 'new',
    then: (schema) =>
      schema.required(t`Email is required`).email(t`Invalid email format`),
  }),
  primaryContactId: yup.string().when('primaryContactOption', {
    is: 'existing',
    then: (schema) => schema.required(t`Select a contact`),
  }),
});

export default primaryContactValidationSchema;
